import styled, { css } from 'styled-components'

import { BackArrow } from '../../icons'
import { color, media, radius, spacing, typography } from '../../themes'

export const Container = styled.div`
  width: 100%;
`

export const SwiperContainer = styled.div`
  margin-top: ${spacing(3)};
`

interface ArrowContainerProps {
  left?: boolean
  right?: boolean
}

export const ArrowContainer = styled.div<ArrowContainerProps>`
  cursor: pointer;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
  z-index: 10;

  ${({ left }) =>
    left &&
    css`
      left: 2px;

      ${media.tablet} {
        left: 10px;
      }
    `}

  ${({ right }) =>
    right &&
    css`
      right: 2px;

      ${media.tablet} {
        right: 10px;
      }
    `}

  &.swiper-button-disabled {
    opacity: 0.3;
  }
`

export const Arrow = styled(BackArrow)`
  ${({ flip }: { flip?: boolean }) =>
    flip &&
    css`
      transform: rotate(180deg);
    `}
`

export const Month = styled.div`
  ${typography('subhead1')};
  width: 100%;
  text-align: center;
  background-color: ${color('gray.05')};
  height: 32px;
  line-height: 32px;
`

interface CalendarItemProps {
  isSelectable?: boolean
  isSelected?: boolean
  isSaturday?: boolean
  isSunday?: boolean
}

export const Calendar = {
  Slide: styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
  `,
  List: styled.ul`
    display: flex;
    flex: 1;
    overflow: auto;
    justify-content: space-between;
    align-items: center;
    max-width: 280px;

    ${media.tablet} {
      max-width: 340px;
    }

    ${media.pc} {
      max-width: 425px;
    }
  `,
  Item: styled.li<CalendarItemProps>`
    text-align: center;

    transition: all 0.3 ease;
    line-height: 16px;
    letter-spacing: 0.2px;
    border-radius: ${radius('md')};
    display: flex;
    justify-content: center;
    align-items: center;
    height: 58px;
    width: 40px;
    min-width: 40px;

    ${media.tablet} {
      height: 58px;
      width: 47px;
      min-width: 47px;
    }

    ${({ isSelectable, isSelected }) =>
      !isSelectable &&
      !isSelected &&
      css`
        opacity: 0.2;
      `}

    ${({ isSelectable, isSelected }) =>
      isSelectable &&
      !isSelected &&
      css`
        cursor: pointer;
      `}

    ${({ isSaturday }) =>
      isSaturday &&
      css`
        color: ${color('blue.02')};
      `}

      ${({ isSunday }) =>
      isSunday &&
      css`
        color: ${color('red.01')};
      `}

    ${({ isSelected }) =>
      isSelected &&
      css`
        color: ${color('white')};
        background: ${color('gradient.primary')};
      `}
  `,
  Date: styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: ${spacing(0.4)};
  `,
  DayOfWeek: styled.div`
    ${typography('body2')};
  `,
  Day: styled.div`
    ${typography('subhead1')};
  `,
}
